import fetch from '../fetch';

const path = process.env.VUE_APP_STATISTICS_SERVER_URL;
const devicePath = process.env.VUE_APP_DEVICE_SERVER_URL;

export const fetchConsumeList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryConsumeList',
    method: 'POST',
    timeout: 30000,
    ...req,
  });
export const fetchReportList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryReportList',
    ...req,
  });
export const fetchTitleList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryTitleList',
    ...req,
  });
export const getRechargeOrderList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryRechargeOrderList',
    method: 'POST',
    ...req,
  });
export const getConsumeOrderList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryConsumeOrderList',
    method: 'POST',
    ...req,
  });
export const getFeedbackList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryFeedbackList',
    ...req,
  });
export const getWarnningCount = req =>
  fetch({
    url: devicePath + '/device/warning/count',
    noErrorAlert: true,
    ...req,
  });
